document.addEventListener("DOMContentLoaded", function () {
    const sortFilter = document.querySelector("#SortBy");
    const productGrid = document.querySelector(".home-prod");
    const myContent = document.querySelector("#myContent");

    let selectValue = sessionStorage.getItem("data-filter");

    if (sortFilter && myContent) {
        if (selectValue) {
            // Set the select dropdown to the saved value
            sortFilter.value = selectValue;

            // Show loading state
            productGrid.classList.add("loading");

            let url = window.location.origin + "/collections/kitchen" + 
                      (window.location.search.includes("?page") ? 
                      window.location.search + "&sort_by=" + selectValue : 
                      "?sort_by=" + selectValue);

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Error loading content: ${response.status} ${response.statusText}`);
                    }
                    return response.text();
                })
                .then(html => {
                    let tempDiv = document.createElement("div");
                    tempDiv.innerHTML = html;

                    let newContent = tempDiv.querySelector("#product-grid.column-grid");
                    let currentGrid = document.querySelector(".home-prod #product-grid.column-grid");

                    if (newContent && currentGrid) {
                        currentGrid.innerHTML = newContent.innerHTML;
                    }

                    setTimeout(() => {
                        productGrid.classList.remove("loading");
                    }, 600);
                })
                .catch(error => console.error(error));
        }

        sortFilter.addEventListener("change", function (event) {
            event.preventDefault();
            productGrid.classList.add("loading");

            sessionStorage.setItem("data-filter", this.value);

            let url = window.location.origin + "/collections/kitchen?sort_by=" + this.value;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Error loading content: ${response.status} ${response.statusText}`);
                    }
                    return response.text();
                })
                .then(html => {
                    let tempDiv = document.createElement("div");
                    tempDiv.innerHTML = html;

                    let newContent = tempDiv.querySelector("#product-grid.column-grid");
                    let currentGrid = document.querySelector(".home-prod #product-grid.column-grid");

                    if (newContent && currentGrid) {
                        currentGrid.innerHTML = newContent.innerHTML;
                    }

                    setTimeout(() => {
                        productGrid.classList.remove("loading");
                    }, 600);
                })
                .catch(error => console.error(error));
        });
    }

	
});
